import {
    FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FETCHING,
    FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_SUCCESS,
    FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FAIL,
    RESET_MENSTRUAL_CYCLING_TRACKING_SUMMARY
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    mctFetching: false,
    mctSummary: null,
    mctStatus: false,
    mctFetchFail: false
};

const menstrualCycleTrackingSummaryFetching = (state) => {
    return {
        ...state,
        mctFetching: true,
        mctFetchFail: false
    };
};

const menstrualCyclingTrackingSummaryFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        mctSummary: isSuccess ? action.mctSummary : null,
        mctStatus: action.mctStatus,
        mctFetching: false,
        mctFetchFail: !isSuccess
    };
};

const resetMenstrualCycleTrackingSummary = () => {
    return INITIAL_STATE;
};

export const isMenstrualCyclingTrackingSummaryFetching = (state) => {
    return state.menstrualCycleTrackingSummary.mctFetching;
};

export const isMenstrualCyclingTrackingSummaryFetchFail = (state) => {
    return state.menstrualCycleTrackingSummary.mctFetchFail;
};

export const getMenstrualCycleTrackingSummary = (state) => {
    return state.menstrualCycleTrackingSummary.mctSummary;
};

export const getMenstrualCycleDayStatus = (state) => {
    return state.menstrualCycleTrackingSummary.mctStatus;
};

const handlers = {
    [FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FETCHING]: menstrualCycleTrackingSummaryFetching,
    [FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_SUCCESS]: menstrualCyclingTrackingSummaryFetchFinished(true),
    [FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FAIL]: menstrualCyclingTrackingSummaryFetchFinished(false),
    [RESET_MENSTRUAL_CYCLING_TRACKING_SUMMARY]: resetMenstrualCycleTrackingSummary
};

export default function menstrualCycleTrackingSummary(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
